module.exports = __webpack_public_path__ + "img/Mb_Lobby_Video.a1428d09.jpg";